export class JpgOrPngConversionResponse {
  converted_file!: string;
}
